import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface FilterActionsProps {
  activeFilterCount: number;
  onApply: () => void;
  onClear: () => void;
}

export const FilterActions = ({
  activeFilterCount,
  onApply,
  onClear,
}: FilterActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-0 left-0 right-0 bg-background border-t p-4 pb-6 space-y-2">
      <div className="flex gap-3">
        <Button
          onClick={onApply}
          className="flex-1 h-14 text-base font-medium shadow-lg"
          size="lg"
        >
          {t("contractorVisits.filter.apply")}
        </Button>
      </div>
      {activeFilterCount > 0 && (
        <Button
          variant="ghost"
          size="default"
          className="w-full h-11 text-sm"
          onClick={onClear}
        >
          {t("contractorVisits.filter.clearAll")} ({activeFilterCount})
        </Button>
      )}
    </div>
  );
};
